require('./addCommentDialog.less');


class AddCommentDialogController {
    comment;

    constructor(private $mdDialog, private toastService){
    }

    $onInit(){    };

    deleteComment() {
        this.comment = '';
    }

    save (comment){
        this.$mdDialog.hide({comment: comment});
    };

    hide () {
        this.$mdDialog.hide();
    };
    cancel () {
        this.$mdDialog.cancel();
    };

}


class AddCommentOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "addCommentDialogController";
    public template: any = require('./addCommentDialog.html');
    bindings: any = {
        comment: '='
    };
}


rkcApp.controller("addCommentDialogController", ['$mdDialog', 'toastService', function ($mdDialog, toastService) {
    return new AddCommentDialogController($mdDialog, toastService);
}])
    .component("addCommentDialog", new AddCommentOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/booking/addCommentDialog/addCommentDialog.ts
 **/